import Mock from 'mockjs'

function fakeSuccess(data) {
    const json = { code: 200, success: true, msg: '操作成功' }
    json.data = data
    return json
}
export default ({ mock }) => {
    if (!mock) return
    // 首页-头部数据
    let topJson = {
        data1: {
            weekCalledIndex: 20,//本周呼叫量
            weekCompare1: "15%",// 周同比
            weekCompare2: "25%",// 周环比
            everydayIndex: 3
        },
        data2: {
            weekFinishIndex: 18,//已经完成
            weekFinishMapData: [0, 1, 0, 3, 5, 4, 9],//图表数据-每天的
            surplusIndex: 3 //剩余没完成的
        },
        data3: {
            weekUnderwayIndex: 3,//在途中
            weekUnderwayMapData: [2, 1, 0, 3, 5, 4, 9],//图表数据-每天的
            underwayRate: "15%"//完成率
        },
        data4: {
            operationEffectRate: 75,//运行效果-百分百
            weekCompare1: "15%",// 周同比
            weekCompare2: "25%"// 周环比
        }
    }
    // 首页-统计数据-接口
    let statisticsJson = {
        xAxisData: [
            '一月',
            '二月',
            '三月',
            '四月',
            '五月',
            '六月',
            '七月',
            '八月',
            '九月',
            '十月',
            '十一月',
            '十二月'
        ],
        seriesList: [
            {
                name: '茶园街道',
                data: [
                    120, 200, 150, 80, 70, 110, 130, 120, 200, 150, 80, 70, 110,
                    130
                ]
            },
            {
                name: '王庄街道',
                data: [
                    120, 200, 150, 80, 70, 110, 130, 120, 200, 150, 80, 70, 110,
                    130
                ]
            },
            {
                name: '象园街道',
                data: [
                    120, 200, 150, 80, 70, 110, 130, 120, 200, 150, 80, 70, 110,
                    130
                ]
            },
            {
                name: '鼓山镇',
                data: [
                    120, 200, 150, 80, 70, 110, 130, 120, 200, 150, 80, 70, 110,
                    130
                ]
            },
            {
                name: '新店镇',
                data: [
                    120, 200, 150, 80, 70, 110, 130, 120, 200, 150, 80, 70, 110,
                    130
                ]
            },
            {
                name: '岳峰镇',
                data: [
                    120, 200, 150, 80, 70, 110, 130, 120, 200, 150, 80, 70, 110,
                    130
                ]
            },
            {
                name: '官溪镇',
                data: [
                    120, 200, 150, 80, 70, 110, 130, 120, 200, 150, 80, 70, 110,
                    130
                ]
            },
            {
                name: '寿山乡',
                data: [
                    120, 200, 150, 80, 70, 110, 130, 120, 200, 150, 80, 70, 110,
                    130
                ]
            },
            {
                name: '日溪乡',
                data: [
                    120, 200, 150, 80, 70, 110, 130, 120, 200, 150, 80, 70, 110,
                    130
                ]
            }
        ]
    }
    // 首页-青少年分布
    let distributionOfYouthData = {
        adolescentData: [
			[4, 81.7, 22162863, "抢夺罪", 2017],
			[2, 81.1, 34126173, "盗窃罪", 2017],
			[1, 75.9, 1340968737, "诈骗罪", 2017],
			[3, 78, 11308133, "抢劫罪", 2017],
			[0, 80, 5367693, "容留他人吸毒罪", 2017],
			[0, 81.2, 62961136, "贩卖毒品罪", 2017],
			[1, 80.2, 80435307, "强奸罪", 2017],
			[1, 82.5, 318042, "强制猥亵妇女罪", 2017],
			[0, 65.1, 1230984504, "猥亵儿童罪", 2017],
			[5, 83, 127319802, "服务救助", 2017],
			[0, 70.8, 24500506, "聚众斗殴罪", 2017],
			[0, 80, 49090041, "寻衅滋事罪", 2017],
			[0, 80.5, 4369027, "校园霸凌罪", 2017],
			[0, 80.9, 4891251, "故意伤害罪", 2017],
			[0, 76.1, 38574682, "校园严重违纪罪", 2017],
			[0, 68.7, 143158099, "绑架罪", 2017],
			[0, 75.7, 72310416, "敲诈勒索罪", 2017],
			[0, 80, 62716684, "交通肇事罪", 2017],
			[0, 78.5, 309876170, "实物救助", 2017],
			
			[4, 81.7, 22162863, "抢夺罪", 2018],
			[2, 81.1, 34126173, "盗窃罪", 2018],
			[1, 75.9, 1340968737, "诈骗罪", 2018],
			[3, 78, 11308133, "抢劫罪", 2018],
			[0, 80, 5367693, "容留他人吸毒罪", 2018],
			[0, 81.2, 62961136, "贩卖毒品罪", 2018],
			[1, 80.2, 80435307, "强奸罪", 2018],
			[1, 82.5, 318042, "强制猥亵妇女罪", 2018],
			[0, 65.1, 1230984504, "猥亵儿童罪", 2018],
			[5, 83, 127319802, "服务救助", 2018],
			[0, 70.8, 24500506, "聚众斗殴罪", 2018],
			[0, 80, 49090041, "寻衅滋事罪", 2018],
			[0, 80.5, 4369027, "校园霸凌罪", 2018],
			[0, 80.9, 4891251, "故意伤害罪", 2018],
			[0, 76.1, 38574682, "校园严重违纪罪", 2018],
			[0, 68.7, 143158099, "绑架罪", 2018],
			[0, 75.7, 72310416, "敲诈勒索罪", 2018],
			[0, 80, 62716684, "交通肇事罪", 2018],
			[0, 78.5, 309876170, "实物救助", 2018],
			
			[4, 81.7, 22162863, "抢夺罪", 2019],
			[2, 81.1, 34126173, "盗窃罪", 2019],
			[1, 75.9, 1340968737, "诈骗罪", 2019],
			[3, 78, 11308133, "抢劫罪", 2019],
			[0, 80, 5367693, "容留他人吸毒罪", 2019],
			[0, 81.2, 62961136, "贩卖毒品罪", 2019],
			[1, 80.2, 80435307, "强奸罪", 2019],
			[1, 82.5, 318042, "强制猥亵妇女罪", 2019],
			[0, 65.1, 1230984504, "猥亵儿童罪", 2019],
			[5, 83, 127319802, "服务救助", 2019],
			[0, 70.8, 24500506, "聚众斗殴罪", 2019],
			[0, 80, 49090041, "寻衅滋事罪", 2019],
			[0, 80.5, 4369027, "校园霸凌罪", 2019],
			[0, 80.9, 4891251, "故意伤害罪", 2019],
			[0, 76.1, 38574682, "校园严重违纪罪", 2019],
			[0, 68.7, 143158099, "绑架罪", 2019],
			[0, 75.7, 72310416, "敲诈勒索罪", 2019],
			[0, 80, 62716684, "交通肇事罪", 2019],
			[0, 78.5, 309876170, "实物救助", 2019],
			
			[4, 81.7, 22162863, "抢夺罪", 2020],
			[2, 81.1, 34126173, "盗窃罪", 2020],
			[1, 75.9, 1340968737, "诈骗罪", 2020],
			[3, 78, 11308133, "抢劫罪", 2020],
			[0, 80, 5367693, "容留他人吸毒罪", 2020],
			[0, 81.2, 62961136, "贩卖毒品罪", 2020],
			[1, 80.2, 80435307, "强奸罪", 2020],
			[1, 82.5, 318042, "强制猥亵妇女罪", 2020],
			[0, 65.1, 1230984504, "猥亵儿童罪", 2020],
			[5, 83, 127319802, "服务救助", 2020],
			[0, 70.8, 24500506, "聚众斗殴罪", 2020],
			[0, 80, 49090041, "寻衅滋事罪", 2020],
			[0, 80.5, 4369027, "校园霸凌罪", 2020],
			[0, 80.9, 4891251, "故意伤害罪", 2020],
			[0, 76.1, 38574682, "校园严重违纪罪", 2020],
			[0, 68.7, 143158099, "绑架罪", 2020],
			[0, 75.7, 72310416, "敲诈勒索罪", 2020],
			[0, 80, 62716684, "交通肇事罪", 2020],
			[0, 78.5, 309876170, "实物救助", 2020],
			
			[4, 81.7, 22162863, "抢夺罪", 2021],
			[2, 81.1, 34126173, "盗窃罪", 2021],
			[1, 75.9, 1340968737, "诈骗罪", 2021],
			[3, 78, 11308133, "抢劫罪", 2021],
			[0, 80, 5367693, "容留他人吸毒罪", 2021],
			[0, 81.2, 62961136, "贩卖毒品罪", 2021],
			[1, 80.2, 80435307, "强奸罪", 2021],
			[1, 82.5, 318042, "强制猥亵妇女罪", 2021],
			[0, 65.1, 1230984504, "猥亵儿童罪", 2021],
			[5, 83, 127319802, "服务救助", 2021],
			[0, 70.8, 24500506, "聚众斗殴罪", 2021],
			[0, 80, 49090041, "寻衅滋事罪", 2021],
			[0, 80.5, 4369027, "校园霸凌罪", 2021],
			[0, 80.9, 4891251, "故意伤害罪", 2021],
			[0, 76.1, 38574682, "校园严重违纪罪", 2021],
			[0, 68.7, 143158099, "绑架罪", 2021],
			[0, 75.7, 72310416, "敲诈勒索罪", 2021],
			[0, 80, 62716684, "交通肇事罪", 2021],
			[0, 78.5, 309876170, "实物救助", 2021],
			
			[4, 81.7, 22162863, "抢夺罪", 2022],
			[2, 81.1, 34126173, "盗窃罪", 2022],
			[1, 75.9, 1340968737, "诈骗罪", 2022],
			[3, 78, 11308133, "抢劫罪", 2022],
			[0, 80, 5367693, "容留他人吸毒罪", 2022],
			[0, 81.2, 62961136, "贩卖毒品罪", 2022],
			[1, 80.2, 80435307, "强奸罪", 2022],
			[1, 82.5, 318042, "强制猥亵妇女罪", 2022],
			[0, 65.1, 1230984504, "猥亵儿童罪", 2022],
			[5, 83, 127319802, "服务救助", 2022],
			[0, 70.8, 24500506, "聚众斗殴罪", 2022],
			[0, 80, 49090041, "寻衅滋事罪", 2022],
			[0, 80.5, 4369027, "校园霸凌罪", 2022],
			[0, 80.9, 4891251, "故意伤害罪", 2022],
			[0, 76.1, 38574682, "校园严重违纪罪", 2022],
			[0, 68.7, 143158099, "绑架罪", 2022],
			[0, 75.7, 72310416, "敲诈勒索罪", 2022],
			[0, 80, 62716684, "交通肇事罪", 2022],
			[0, 78.5, 309876170, "实物救助", 2022],
        ]
    }
    // 首页-年龄段分布-接口
    let adolescentJson = {
        xAxisData: [
            '一月',
            '二月',
            '三月',
            '四月',
            '五月',
            '六月',
            '七月',
            '八月',
            '九月',
            '十月',
            '十一月',
            '十二月'
        ],
        seriesList: [
            {
                name: "5-8岁",
                data: [
                    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0,
                ],
            },
            {
                name: "9-12岁",
                data: [
                    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0,
                ],
            },
            {
                name: "13-15岁",
               data: [
                   0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                   0,
               ],
            }, {
                name: "16-18岁",
                data: [
                    0, 0, 4, 57, 16, 3, 1, 23, 1, 3, 5,
                    5,
                ],
            }, {
                name: "19-22岁",
                data: [
                    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0,
                ],
            }, {
                name: "23-25岁",
                data: [
                    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0,
                ],
            }
        ]
    }
    //首页-五类青少年分布-接口
    let adolescentKindJson={
        sourceList:[
            {
                name: "茶园街道",
                data1: 4,//闲散青少年
                data2: 2,//有或(严重)不良行为青少年
                data3: 2,//流浪乞讨青少年
                data4: 8,//服刑在教人员未成年子女
                data5: 3,//农村留守儿童
            },
            {
                name: "王庄街道",
                data1: 2,//闲散青少年
                data2: 1,//有或(严重)不良行为青少年
                data3: 7,//流浪乞讨青少年
                data4: 4,//服刑在教人员未成年子女
                data5: 6,//农村留守儿童
            },
            {
                name: "象园街道",
                data1: 3,//闲散青少年
                data2: 5,//有或(严重)不良行为青少年
                data3: 3,//流浪乞讨青少年
                data4: 5,//服刑在教人员未成年子女
                data5: 6,//农村留守儿童
            },
            {
                name: "鼓山镇",
                data1: 3,//闲散青少年
                data2: 4,//有或(严重)不良行为青少年
                data3: 5,//流浪乞讨青少年
                data4: 1,//服刑在教人员未成年子女
                data5: 6,//农村留守儿童
            },
            {
                name: "新店镇",
                data1: 5,//闲散青少年
                data2: 2,//有或(严重)不良行为青少年
                data3: 4,//流浪乞讨青少年
                data4: 5,//服刑在教人员未成年子女
                data5: 2,//农村留守儿童
            },
            {
                name: "岳峰镇",
                data1: 2,//闲散青少年
                data2: 1,//有或(严重)不良行为青少年
                data3: 0,//流浪乞讨青少年
                data4: 0,//服刑在教人员未成年子女
                data5: 2,//农村留守儿童
            },
            {
                name: "官溪镇",
                data1: 2,//闲散青少年
                data2: 3,//有或(严重)不良行为青少年
                data3: 2,//流浪乞讨青少年
                data4: 1,//服刑在教人员未成年子女
                data5: 2,//农村留守儿童
            },
            {
                name: "寿山乡",
                data1: 1,//闲散青少年
                data2: 2,//有或(严重)不良行为青少年
                data3: 2,//流浪乞讨青少年
                data4: 6,//服刑在教人员未成年子女
                data5: 2,//农村留守儿童
            },
            {
                name: "日溪乡",
                data1: 4,//闲散青少年
                data2: 2,//有或(严重)不良行为青少年
                data3: 2,//流浪乞讨青少年
                data4: 2,//服刑在教人员未成年子女
                data5: 1,//农村留守儿童
            },
        ]
        
    }
    //首页-工作信息统计-接口
    let jobInformationData = {
        dataList: [
            {
                name: '防艾宣传',
                value: 0
            },
            {
                name: '青少年服务',
                value: 0
            },
            {
                name: '个护健康',
                value: 0
            },
            {
                name: '助残助盲',
                value: 1
            },
            {
                name: '健康进校园',
                value: 0
            },
            {
                name: '志愿服务',
                value: 7
            },
            {
                name: '其他',
                value: 0
            }
        ]
    }
    // 首页-头部信息
    Mock.mock(
        /\/api\/blade-stat\/wel\/topData/,
        'get',
        fakeSuccess(topJson)
    )
    // 首页-统计数据-接口
    Mock.mock(
        /\/api\/blade-stat\/wel\/statisticsData/,
        'post',
        fakeSuccess(statisticsJson)
    )
    // 首页-青少年分布-接口
    Mock.mock(
        /\/api\/blade-stat\/wel\/distributionOfYouthData/,
        'get',
        fakeSuccess(distributionOfYouthData)
    )
    // 首页-年龄段分布-接口
    Mock.mock(
        /\/api\/blade-stat\/wel\/ageBracketData/,
        'post',
        fakeSuccess(adolescentJson)
    )
    //首页-五类青少年分布-接口
    Mock.mock(
        /\/api\/blade-stat\/wel\/adolescentKindData/,
        'get',
        fakeSuccess(adolescentKindJson)
    )
    //首页-工作信息统计-接口
    Mock.mock(
        /\/api\/blade-stat\/wel\/jobInformationData/,
        'post',
        fakeSuccess(jobInformationData)
    )

}
